module.exports = __webpack_public_path__ + "static/media/SohoGothicProRegular.0c9b6100.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/SohoGothicProRegular.woff2
// module id = 831
// module chunks = 0